import { useTranslation } from 'react-i18next';

import { colors } from '@packages/design';

import { Assets } from '@assets';
import { Text } from '@elements/text';

export type MoreInfoModalBodyProps = {
  modalType?: string;
};

export function MoreInfoModalBody({ modalType }: MoreInfoModalBodyProps) {
  const { t } = useTranslation();
  const residentContentList = t('travellers.residentStatus.modal.content', {
    returnObjects: true,
  });
  const moreInfoModalI18Text = modalType
    ? t('travellers.dependent.modal.title')
    : t('travellers.residentStatus.modal.title');

  if (!modalType) {
    return (
      <div>
        <Text variant="h4-24/sb" className="mb-s16">
          {moreInfoModalI18Text}
        </Text>
        <Text className="py-2">{t('travellers.residentStatus.modal.subtitle')}</Text>
        <ul>
          {residentContentList?.map((item: string, index: number) => {
            return (
              <li key={index} className="flex flex-row justify-center py-2">
                <Assets.Covered fill={colors.green[500]} className="pt-1" />
                <Text className="px-2 flex-1">{item}</Text>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  return (
    <div className="text-center">
      <Text variant="h4-24/sb" className="mb-s16">
        {moreInfoModalI18Text}
      </Text>
      <Text>{t('travellers.dependent.modal.content')}</Text>
    </div>
  );
}
